import * as React from 'react';

import { TableHead, TableRow } from 'components/table';

import { __t, applyTranslations } from 'utils/language';

import './ccm-campaigns-table-head.scss';

applyTranslations(require('./ccm-campaigns-table-head.i18n.json'));

const MSG_KEY = 'ccm_campaigns_table_head';

const CcmCampaignsTableHead = () => (
  <TableRow
    nowrap
    className="ccm-campaigns-table-head"
  >
    <TableHead width="tiny">
      {__t(`${MSG_KEY}.columns.brand`)}
    </TableHead>

    <TableHead width="fill">
      {__t(`${MSG_KEY}.columns.campaign`)}
    </TableHead>

    <TableHead width="148px">
      {__t(`${MSG_KEY}.columns.outfits`)}
    </TableHead>

    <TableHead width="214px">
      {__t(`${MSG_KEY}.columns.budget`)}
    </TableHead>

    <TableHead width="270px">
      {__t(`${MSG_KEY}.columns.actions`)}
    </TableHead>
  </TableRow>
);

export default CcmCampaignsTableHead;
